import { Component, OnInit, Input } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { LocalStorage } from "src/app/core/helpers/local-storage";
import { FormBuilder, FormGroup } from "@angular/forms";
import { PluggyConnect } from "pluggy-connect-sdk";
import { ActivatedRoute } from "@angular/router";
import Swal from "sweetalert2";

import { ApiServiceClientsFinance } from "../../core/services/clients-finance.service";
import { ApiServiceOpenFinance, DataGetItems } from "../../core/services/open-finance.service";
import { OpenFinance } from "../../core/interfaces/open-finance.interface";

@Component({
  selector: "open-finance-dialog",
  templateUrl: "open-finance-dialog.html",
  styleUrls: ["./open-finance-dialog.scss"]
})
export class OpenFinanceDialog implements OnInit {
  listClient: Array<Object> = [];
  listOpenFinance: Array<OpenFinance> = [];
  formDigitalAccount: FormGroup;

  page: number = 1;
  totalResults: number = 10;
  user = LocalStorage.getItem("currentUser");

  @Input() idClient: any;
  idRequest: string;
  updateItem: string;
  pluggyConnect: any;

  formFilter: FormGroup = this.formBuilder.group({
    filter: [null]
  });

  constructor(
    public dialogRef: MatDialogRef<OpenFinanceDialog>,
    private apiServiceClientsFinance: ApiServiceClientsFinance,
    private apiServiceOpenFinance: ApiServiceOpenFinance,
    private activatedRoute: ActivatedRoute,
    private formBuilder: FormBuilder
  ) {}

  ngOnInit() {
    this.getListOpenFinance();
  }

  get filter() {
    return this.formFilter.value.filter;
  }

  getListOpenFinance() {
    this.apiServiceOpenFinance.getItems(this.idClient).subscribe({
      next: res => {
        this.listOpenFinance = res;
        if (res.length === 0) {
          this.createWidgetPluggy();
        }
      },
      error: error => {}
    });
  }

  createWidgetPluggy() {
    this.apiServiceClientsFinance.getToken().subscribe({
      next: res => {
        this.pluggyConnect = new PluggyConnect({
          connectToken: res.accessToken,
          includeSandbox: true,
          onSuccess: (itemData: any) => {
            let data = {
              item_uuid: itemData.item.id,
              client_uuid: this.idClient
            };
            this.apiServiceOpenFinance.addItemOpenFinance(data).subscribe({
              next: () => {
                this.getListOpenFinance();
              },
              error: error => {
                throw Error(error.message);
              }
            });
          },
          onError: error => {
            console.error("Whoops! Pluggy Connect error... ", error);
          }
        });
        this.pluggyConnect.init();
      },
      error: error => {
        throw Error(error.message);
      }
    });
  }

  updateWidgetPluggy(updateItem: string) {
    this.apiServiceClientsFinance.getToken().subscribe({
      next: res => {
        this.pluggyConnect = new PluggyConnect({
          connectToken: res.accessToken,
          updateItem: updateItem,
          includeSandbox: true,
          onSuccess: (itemData: any) => {
            this.getListOpenFinance();
          },
          onError: error => {
            console.error("Whoops! Pluggy Connect error... ", error);
          }
        });
        this.pluggyConnect.init();
      },
      error: error => {
        throw Error(error.message);
      }
    });
  }

  alert(title: string, icon: any) {
    Swal.fire({
      type: icon,
      title: title,
      showConfirmButton: false,
      timer: 1500
    });
  }
}
